import React from 'react';
import gameAssets from '@themed-assets';
import { useNavigate } from 'react-router';
import BellIcon from '@/src/assets/BellIcon';

function TourneyDetailsHeader({ title, handleNotification, showNotification }) {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };
  return (
    <div className={'bg-foreground flex items-center justify-between p-4'}>
      <div className={`flex items-center gap-2`}>
        <button
          onClick={goBack}
          className={`text-primary flex items-center justify-center text-lg`}
        >
          <img src={gameAssets.backArrow} alt="Navigate back" />
        </button>

        <div className={`text-primary flex gap-2 text-base font-medium`}>
          <span>{title}</span>
        </div>
      </div>
      {showNotification && (
        <div className={`flex items-center gap-2`}>
          <div
            className={'flex items-center p-2'}
            onClick={() => handleNotification()}
          >
            <BellIcon />
          </div>
        </div>
      )}
    </div>
  );
}

export default TourneyDetailsHeader;
